import { createAction, props } from '@ngrx/store';
import { ISetupStatusResponse } from '../models/setup-status.model';

export const loadRegulationVerified = createAction('[RegulationVerified] Load RegulationVerified', props<{ businessId: string }>());

export const loadRegulationVerifiedSuccess = createAction(
  '[RegulationVerified] Load RegulationVerified Success',
  props<{ response: ISetupStatusResponse }>()
);

export const loadRegulationVerifiedFailure = createAction(
  '[RegulationVerified] Load RegulationVerified Failure',
  props<{ error: Error | any }>()
);
